document.addEventListener("DOMContentLoaded", function() {
  const apiToken = 'd0b101723f3d0e'; // ipinfo.io token
  const CACHE_KEY = 'user_location_cache_v1';
  const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours (tweak if needed)

  function readCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const { location, ts } = JSON.parse(raw);
      if (!location || !ts) return null;
      if (Date.now() - ts > CACHE_TTL_MS) return null; // expired
      return location;
    } catch {
      return null;
    }
  }

  function writeCache(location) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ location, ts: Date.now() }));
    } catch {}
  }

  async function getLocationFromIP() {
    try {
      const response = await fetch(`https://ipinfo.io?token=${apiToken}`);
      const data = await response.json();

      if (!data || !data.city) throw new Error('Unable to determine location from IP');

      const loc = {
        city: data.city,
        state: data.region,
        zip: data.postal,
        country: data.country
      };

      writeCache(loc);
      return loc;
    } catch (err) {
      console.error('Error fetching location:', err);
      return null;
    }
  }

  (async () => {
    let location = readCache();
    if (!location) {
      location = await getLocationFromIP();
    }

    if (!location) return; // give up if we can't detect

    // Make location available to other theme scripts (cart shipping estimator, etc.)
    try {
      window.customerLocation = location;
      window.dispatchEvent(new CustomEvent('shellz:customer-location', { detail: location }));
    } catch {}

    if (location.country !== 'US') {
      const css = `
        #openPopupBtn,
        .discounted_price,
        .points_box {
          display: none !important;
        }
      `;

      const style = document.createElement('style');
      style.textContent = css;
      document.head.appendChild(style);
    }
  })();
});